import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MailAccountsService } from 'src/app/configuration/mail-accounts/mail-accounts.service';
import { UserMailAccountsService } from './user-mail-accounts.service';

@Component({
  selector: 'app-users-mail-accounts-detail',
  templateUrl: './users-mail-accounts-detail.component.html',
  styleUrls: ['./users-mail-accounts-detail.component.scss']
})
export class UsersMailAccountsDetailComponent implements OnInit {
  public mailAccounts: any[] = [];
  public selectedMailAccounts: any[] = [];
  public userMailAccount: any = {};

  constructor(
    private userMailAccountsService: UserMailAccountsService,
    private mailAccountsService: MailAccountsService,

    private messageService: MessageService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef
  ) { }

  ngOnInit(): void {
    this.userMailAccount.user_id = this.config.data.user.id;
    this.selectedMailAccounts = this.config.data.selectedMailAccounts;
    this.loadMailAccounts();
  }
  cancel() {
    this.dynamicDialogRef.close();
  }
  save() {
    if (this.userMailAccount != null && this.userMailAccount.mailAccount_id > 0) {
      this.userMailAccountsService.add(this.userMailAccount).subscribe(
        data => {
          this.messageService.add({ closable: false, severity: "success", detail: "Cuenta de correo asignada correctamente" });
          this.dynamicDialogRef.close(data);
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      );
    } else {
      this.messageService.add({ closable: false, severity: "error", detail: "¡Debes seleccionar una cuenta de correo!" })
    }
  }

  loadMailAccounts() {
    this.mailAccountsService.all({ ids: this.selectedMailAccounts }).subscribe(
      data => {
        this.mailAccounts = data.rows;
      },
      error => {
        this.messageService.add({ closable: false, severity: 'error', summary: 'Error', detail: error.error.title });
      }
    )
  }
}
